import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const SimpleGoogleIcon = withTheme(
  ({ title, theme, width, height, viewBox = "0 0 20 20", type }) => (
    <svg
      width={width}
      height={height}
      title={title}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
    >
      <g fill="none" fillRule="evenodd">
        <g
          fill={
            type === "alternative" ? theme.onPrimaryColor : theme.primaryColor
          }
          fillRule="nonzero"
        >
          <g>
            <g>
              <path
                d="M19.914 8.75H8.75v3.75h5.555C13.438 13.988 11.842 15 10 15c-2.758 0-5-2.242-5-5s2.242-5 5-5c1.256 0 2.393.481 3.273 1.25h5.99C17.777 2.59 14.188 0 10 0 4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10c0-.424-.035-.84-.086-1.25z"
                transform="translate(-86 -255) translate(86 254) translate(0 1)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
);

export const GoogleIcon = ({ type, title }) => (
  <Icon>
    <SimpleGoogleIcon
      width="30"
      height="30"
      viewBox="0 0 20 20"
      title={title}
      type={type}
    />
  </Icon>
);

GoogleIcon.propTypes = {
  theme: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
  title: PropTypes.string
};

GoogleIcon.defaultProps = {
  title: "Google Icon",
  type: "secondary"
};

export default withTheme(GoogleIcon);
